/* eslint-disable immutable/no-mutation */
import snakeCase from 'lodash/snakeCase';
import { AUTH } from '../../constants/strings';

const getErrorMsg = triggers =>
  Object.keys(triggers).reduce((acc, key) => {
    if (!triggers[key]) {
      acc.push(AUTH.errors[key]);
    }

    return acc;
  }, []);

export default (form, validations, formatMessage) => {
  const triggers = Object.keys(validations).reduce((acc, key) => {
    const { fields, handler } = validations[key];
    acc[key] = fields.every(fieldName =>
      handler(form[snakeCase(fieldName)], formatMessage),
    );

    return acc;
  }, {});

  const errors = getErrorMsg(triggers);
  return errors.length ? errors : null;
};



// WEBPACK FOOTER //
// ./src/utils/auth/validateForm.js